<script setup lang="ts">
// #719 観点B: モバイルナビ背景に敷くエリアのマップ画像。
import forestMapBg from '@/assets/images/map/AreaMap_SilverLeafForest.webp'

const runtimeConfig = useRuntimeConfig()

const { isMobile } = useIsMobile()

useSeoMeta({
  title: 'シルバーリーフの森 | Code & Magic',
  description: 'エンコーディア南部の穏やかな地域にある深い森です。',
  ogTitle: 'シルバーリーフの森 | Code & Magic',
  ogDescription: 'エンコーディア南部の穏やかな地域にある深い森です。',
  ogImage: `${runtimeConfig.public.serviceDomain}/images/ogPlayMakeShare_wLogo.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  middleware: ['authenticated', 'confirm-game-state'],
  layout: false,
  usePageReady: true,
})

const { finishLoading } = usePageReady()

onMounted(async () => {
  await finishLoading()
})
</script>

<template>
  <NuxtLayout :name="isMobile ? 'mobile-nav' : 'centering43'">
    <SceneMap
      scene-id="wld_silverLeafForest"
      :mobile="isMobile"
      :mobile-background="forestMapBg"
    >
      <template #map>
        <v-img
          src="@/assets/images/map/AreaMap_SilverLeafForest.webp"
          width="100%"
          height="auto"
          lazy-src="@/assets/images/map/LazyAreaMap_SilverLeafForest.png"
          :transition="false"
        />
        <svg
          class="map-area"
          width="100%"
          height="100%"
          viewBox="0 0 1024 768"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          style="
          fill-rule: evenodd;
          clip-rule: evenodd;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 1.5;
        "
        >
          <path
            d="M252.564,151.053C252.564,128.739 264.793,71.548 287.504,63.032C292.749,61.065 369.892,66.071 390.979,69.751C412.176,73.449 418.467,78.149 432.737,84.902C439.62,88.159 459.812,100.722 468.249,106.034C476.324,111.118 487.02,114.742 493.11,120.816C496.211,123.909 512.237,132.183 511.924,141.646C511.442,156.233 503.962,173.023 499.45,182.699C495.811,190.503 488.406,211.147 479.758,220.466C475.682,224.858 442.619,242.008 430.622,245.793C421.201,248.765 338.733,273.759 320.428,264.606C310.903,259.844 278.665,212.66 272.722,200.774C271.352,198.034 254.517,153.981 252.564,151.053"
            class="scene"
            data-scene-id="slf_leaningTreeGhost"
          />
          <path
            d="M456.827,271.997C465.594,265.422 494.66,235.466 517.235,233.435C541.806,231.224 591.659,252.189 611.368,268.638C618.511,274.6 630.785,305.104 632.869,312.984C634.975,320.951 637.171,341.075 638.244,343.22C640.255,347.242 641.054,379.382 638.244,382.192C626.485,393.951 618.138,406.875 603.305,415.115C592.107,421.336 569.71,426.642 547.836,431.499C520.848,437.493 525.852,435.122 483.703,434.601C478.872,434.541 457.839,421.223 452.123,416.459C442.98,408.84 435.333,402.039 431.966,390.255C429.8,382.673 426.211,347.695 429.95,339.189C434.692,328.402 433.531,307.088 456.827,271.997Z"
            class="scene"
            data-scene-id="slf_lonehillCedar"
          />
          <path
            d="M672.2,393.63C685.392,389.233 713.771,377.332 739.031,378.16C766.929,379.075 782.464,385.865 808.11,397.468C825.892,405.514 835.931,413.733 841.835,423.178C847.792,432.71 848.822,477.875 846.538,487.011C845.9,489.564 839.614,507.475 835.787,513.215C832.289,518.463 808.838,554.475 802.192,558.905C796.109,562.96 768.801,579.316 757.845,581.751C745.351,584.527 678.796,594.299 663.105,586.454C643.189,576.496 624.937,527.048 624.134,524.638C615.147,497.678 625.052,449.691 627.434,443.707C636.534,420.846 650.527,409.063 672.2,393.63Z"
            class="scene"
            data-scene-id="slf_silverGleamingRock"
          />
        </svg>
      </template>
    </SceneMap>
  </NuxtLayout>
</template>
